const tintColor = '#FFFFFF';

export default {
  tintColor,
  mediumBlue: '#01579B',
  darkBlue: '#1B2E7A',
  lightBlue: '#4B84B6',
  backgroundBlue: '#0F77BA',
  white: '#FFFFFF',
  black: '#000000',
  primaryColor: '#008763',
  accentColor: '#00BFA5',
  tabIconDefault: '#9ABCD7',
  tabIconSelected: tintColor,
  tabBar: '#FEFEFE',
  errorBackground: '#D14141',
  brightRed: '#EF5350',
  errorText: '#FFFFFF',
  warningBackground: '#FFAF47',
  warningText: '#FFFFFF',
  noticeBackground: tintColor,
  noticeText: '#FFFFFF',
  grayBorder: '#E5EAEA',
  inputGrayBorder: '#D9D5DC',
  lightBlack: '#343434',
  veryDarkGray: '#333333',
  mediumGray: '#6F747B',
  lightGray: '#AAB1B9',
  grayText: '#333333',
  grayButton: '#CED3D6',
  grayInfoText: '#696969',
  lightBackground: '#F7FAFA',
  lightGrayBackground: '#F7F9FA',
  iconGray: '#333333',
  iconLightGray: '#D7DDE0',
  profileVerified: '#20B093',
  inputGray: '#8CB4D5',
  darkGreen: '#007363',
  mapButtonGrayBorder: '#C9CBCE',
  siteListPaleGreenBg: '#E7F0EB',
  siteListPaleGreenBorder: '#CFE0D7',
  siteListClosedDot: '#8A9A92',
  siteListReservationBg: '#FDF0E1',
  siteListReservationBorder: '#F0D3AE',
  siteListReservationText: '#8A4B08',
  siteListPreRegistrationBg: '#EAF0FB',
  siteListPreRegistrationBorder: '#C7D9F5',
  siteListPreRegistrationText: '#2B4C8C',
  siteListUnconfirmedBg: '#F9F7F2',
  siteListUnconfirmedBorder: '#DFD5C2',
  siteListUnconfirmedText: '#6B5A2E',
  bookingBadgeReservationBackground: '#FDF0E1',
  bookingBadgeReservationBorder: '#F0D3AE',
  bookingBadgeReservationText: '#8A4B08',
  bookingBadgePreRegistrationBackground: '#EAF0FB',
  bookingBadgePreRegistrationBorder: '#C7D9F5',
  bookingBadgePreRegistrationText: '#2B4C8C',
  bookingBadgeWalkInBackground: '#E7F0EB',
  bookingBadgeWalkInText: '#00543A',
};
